import Maybe from 'folktale/maybe'
import type { ComponentRef } from '@wix/editor-platform-sdk-types'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'

interface Params {
  repeaterRef: ComponentRef
  componentRef: ComponentRef
  editorSdkProxy: EditorSDK
}

export async function getRepeaterItemAncestor({
  repeaterRef,
  componentRef,
  editorSdkProxy,
}: Params) {
  const ancestorsRefs = await editorSdkProxy.components.getAncestors({
    componentRef,
  })
  if (ancestorsRefs.length === 0) {
    return Maybe.Nothing()
  }

  const ancestors = await editorSdkProxy.components.get({
    componentRefs: ancestorsRefs,
    properties: ['sdkType', 'connections'],
  })
  const repeaterIndex = ancestors.findIndex(
    ({ componentRef }: { componentRef: ComponentRef }) =>
      componentRef.id === repeaterRef.id,
  )
  const itemContainer = ancestors[repeaterIndex - 1]

  return itemContainer
    ? Maybe.Just(itemContainer.componentRef)
    : Maybe.Nothing()
}
